<template>
  <section id="main">
    <h1 class="fs-21 w-bold darks mb-4">Editar perfil conecta</h1>

    <article
      v-if="statusMessage"
      class="c-card-alert p-3 mb-4"
      :class="`c-card-alert--${statusMessage.type}`"
    >
      {{statusMessage.text}}
    </article>

    <b-skeleton-wrapper :loading="isLoading">
      <template #loading>
        <div class="row gy-5">
          <div class="col-12">
            <div class="row gy-3">
              <div class="col-12">
                <b-skeleton
                  no-aspect
                  animation="fade"
                  width="50%"
                  class="light"
                ></b-skeleton>
              </div>
              <div class="col-12">
                <div class="row gx-3 gy-3">
                  <div class="col-12 col-md-6">
                    <b-skeleton
                      no-aspect
                      animation="fade"
                      height="40px"
                      class="light"
                    ></b-skeleton>
                  </div>
                  <div class="col-12 col-md-6">
                    <b-skeleton
                      no-aspect
                      animation="fade"
                      height="40px"
                      class="light"
                    ></b-skeleton>
                  </div>
                  <div class="col-12 col-md-6">
                    <b-skeleton
                      no-aspect
                      animation="fade"
                      height="40px"
                      class="light"
                    ></b-skeleton>
                  </div>
                  <div class="col-12 col-md-6">
                    <b-skeleton
                      no-aspect
                      animation="fade"
                      height="40px"
                      class="light"
                    ></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row gy-3">
              <div class="col-12">
                <b-skeleton
                  no-aspect
                  animation="fade"
                  width="50%"
                  class="light"
                ></b-skeleton>
              </div>
              <div class="col-12">
                <div class="row gx-3 gy-3">
                  <div class="col-12 col-md-6">
                    <b-skeleton
                      no-aspect
                      animation="fade"
                      height="40px"
                      class="light"
                    ></b-skeleton>
                  </div>
                  <div class="col-12 col-md-6">
                    <b-skeleton
                      no-aspect
                      animation="fade"
                      height="40px"
                      class="light"
                    ></b-skeleton>
                  </div>
                  <div class="col-12 col-md-6">
                    <b-skeleton
                      no-aspect
                      animation="fade"
                      height="40px"
                      class="light"
                    ></b-skeleton>
                  </div>
                  <div class="col-12 col-md-6">
                    <b-skeleton
                      no-aspect
                      animation="fade"
                      height="40px"
                      class="light"
                    ></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="row gy-5">
        <div class="col-12">
          <div class="row gy-5">
            <div class="col-12">
              <div class="c-form c-form--ghost">
                <div class="row gx-3 gy-3">
                  <div class="col-12 col-lg-6">
                    <div
                      class="c-form-group"
                      :class="{'c-form-group--error' : $v.profile.firstname.$error}"
                    >
                      <label class="w-sbold fs-14 mb-1">Nombres*</label>
                      <input
                        v-model="$v.profile.firstname.$model"
                        class="c-form__input d-block w-100 tiny"
                        type="text"
                        placeholder="ejmp. Diseñador de interiores"
                      />

                      <span
                        v-if="!$v.profile.firstname.required"
                        class="c-form__error"
                      >
                        Nombres requeridos
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div
                      class="c-form-group"
                      :class="{'c-form-group--error' : $v.profile.lastname.$error}"
                    >
                      <label class="w-sbold fs-14 mb-1">Apellidos*</label>
                      <input
                        v-model="$v.profile.lastname.$model"
                        class="c-form__input d-block w-100 tiny"
                        type="text"
                        placeholder="ejmp. Diseñador de interiores"
                      />

                      <span
                        v-if="!$v.profile.lastname.required"
                        class="c-form__error"
                      >
                        Apellidos requeridos
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div
                      class="c-form-group"
                      :class="{'c-form-group--error' : $v.profile.job_grade.$error}"
                    >
                      <label class="w-sbold fs-14 mb-1">Experiencia*</label>
                      <select
                        v-model="$v.profile.job_grade.$model"
                        class="c-form__select d-block w-100 tiny"
                      >
                        <option value="" selected disabled>Seleccionar</option>
                        <option value="estudiante">Estudiante</option>
                        <option value="profesional">Profesional</option>
                      </select>

                      <span
                        v-if="!$v.profile.job_grade.required"
                        class="c-form__error"
                      >
                        Experiencia requerida
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div
                      class="c-form-group"
                      :class="{'c-form-group--error' : $v.profile.job.$error}"
                    >
                      <label class="w-sbold fs-14 mb-1">Profesión y/o grado académico*</label>
                      <input
                        v-model="$v.profile.job.$model"
                        class="c-form__input d-block w-100 tiny"
                        type="text"
                        placeholder="ejmp. Diseñador de interiores"
                      />

                      <span
                        v-if="!$v.profile.job.required"
                        class="c-form__error"
                      >
                        Profesion y/o grado schedule requerido
                      </span>
                      <span
                        v-else-if="!$v.profile.job.minLength"
                        class="c-form__error"
                      >
                        Debe tener minimo
                        {{ $v.profile.job.$params.minLength.min }}
                        digitos
                      </span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="c-form-group"
                      :class="{'c-form-group--error' : $v.profile.schedule.$error}"
                    >
                      <label class="w-sbold fs-14 mb-1">Horario*</label>
                      <select
                        v-model="$v.profile.schedule.$model"
                        class="c-form__select d-block w-100 tiny"
                      >
                        <option value="" selected disabled>Seleccionar</option>
                        <option value="full-time">Full Time</option>
                        <option value="part-time">Part Time</option>
                        <option value="freelance">Freelance</option>
                      </select>

                      <span
                        v-if="!$v.profile.schedule.required"
                        class="c-form__error"
                      >
                        Horario requerido
                      </span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="c-form-group"
                      :class="{'c-form-group--error' : $v.profile.description.$error}"
                    >
                      <label class="w-sbold fs-14 mb-1">Descripción*</label>
                      <textarea
                        v-model="$v.profile.description.$model"
                        class="c-form__textarea d-block w-100 tiny-expanded"
                        rows="5"
                        type="text"
                        placeholder="ejmp. Hola, mi nombre es Cleiver"
                      ></textarea>

                      <span
                        v-if="!$v.profile.description.required"
                        class="c-form__error"
                      >
                        Descripción requerida
                      </span>
                      <span
                        v-else-if="!$v.profile.description.minLength"
                        class="c-form__error"
                      >
                        Debe tener minimo
                        {{ $v.profile.description.$params.minLength.min }}
                        digitos
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div
                      class="c-form-group"
                      :class="{'c-form-group--error' : $v.profile.skills.$error}"
                    >
                      <label class="w-sbold fs-14 mb-1">Habilidades*</label>
                      <select
                        v-model="profile.skillSelector"
                        @change="updateSkills()"
                        class="c-form__select d-block w-100 tiny"
                      >
                        <option value="" selected disabled>Seleccionar (varios)</option>
                        <option
                          v-for="option of softwares"
                          :key="`option-skill-${option.slug}`"
                          :value="option.slug"
                        >
                          {{option.name}}
                        </option>
                      </select>

                      <span
                        v-if="!$v.profile.skills.required"
                        class="c-form__error"
                      >
                        Debe seleccionar 1 habilidad como minimo
                      </span>
                    </div>

                    <div class="c-profile-tags dark-gray w-medium fs-14 mt-3">
                      <span
                        v-for="skill of profile.skills"
                        :key="skill"
                        class="c-tag-v2 c-tag-v2--third ghost d-flex align-items-center">
                        {{skill}}
                        <button
                          @click="removeItem('skill', skill)"
                          class="c-link c-link--third d-flex align-items-center"
                        >
                          <Icon icon="ant-design:close-outlined" class="ms-2"/>
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div
                      class="c-form-group"
                      :class="{'c-form-group--error' : $v.profile.languages.$error}"
                    >
                      <label class="w-sbold fs-14 mb-1">Idiomas*</label>
                      <select
                        v-model="profile.languageSelector"
                        @change="updateLanguages()"
                        class="c-form__select d-block w-100 tiny"
                      >
                        <option value="" selected disabled>Seleccionar (varios)</option>
                        <option value="ingles">Ingles</option>
                        <option value="español">Español</option>
                      </select>

                      <span
                        v-if="!$v.profile.description.required"
                        class="c-form__error"
                      >
                        Debe seleccionar 1 idioma como minimo
                      </span>
                    </div>

                    <div class="c-profile-tags dark-gray w-medium fs-14 mt-3">
                      <span
                        v-for="language of profile.languages"
                        :key="language"
                        class="c-tag-v2 c-tag-v2--third ghost d-flex align-items-center">
                        {{language}}
                        <button
                          @click="removeItem('language', language)"
                          class="c-link c-link--third d-flex align-items-center"
                        >
                          <Icon icon="ant-design:close-outlined" class="ms-2"/>
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-12">
                    <Educations />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="row gy-3">
                <div class="col-12">
                  <h1 class="fs-18 w-bold darks mb-0">
                    <Icon icon="ion:share-social-sharp" class="me-2 fs-21" />
                    Redes Sociales
                  </h1>
                </div>
                <div class="col-12">
                  <div class="c-form c-form--ghost">
                    <div class="row gx-3 gy-3">
                      <div class="col-12 col-md-6">
                        <label class="w-sbold fs-14 mb-1">Facebook</label>
                        <input
                          v-model="profile.facebook"
                          class="c-form__input d-block w-100 tiny"
                          type="text"
                          placeholder="Ej. https://facebook.com/usuario"
                        />
                      </div>
                      <div class="col-12 col-md-6">
                        <label class="w-sbold fs-14 mb-1">Instagram</label>
                        <input
                          v-model="profile.instagram"
                          class="c-form__input d-block w-100 tiny"
                          type="text"
                          placeholder="Ej. https://instagram.com/usuario"
                        />
                      </div>
                      <div class="col-12 col-md-6">
                        <label class="w-sbold fs-14 mb-1">Linkedin</label>
                        <input
                          v-model="profile.linkedin"
                          class="c-form__input d-block w-100 tiny"
                          type="text"
                          placeholder="Ej. https://linkedin.com/usuario"
                        />
                      </div>
                      <div class="col-12 col-md-6">
                        <label class="w-sbold fs-14 mb-1">Twitter</label>
                        <input
                          v-model="profile.twitter"
                          class="c-form__input d-block w-100 tiny"
                          type="text"
                          placeholder="Ej. https://twitter.com/usuario"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="row gy-3">
                <div class="col-12">
                  <h1 class="fs-18 w-bold darks mb-0">
                    <Icon icon="ic:outline-email" class="me-2 fs-21" />
                    Contacto
                  </h1>
                </div>

                <div class="col-12">
                  <div class="c-form c-form--ghost">
                    <div class="row gx-3 gy-3">
                      <div class="col-12 col-md-6">
                        <div
                          class="c-form-group"
                          :class="{'c-form-group--error' : $v.profile.email.$error}"
                        >
                          <label class="w-sbold fs-14 mb-1">Email de contacto*</label>
                          <input
                            v-model="$v.profile.email.$model"
                            class="c-form__input d-block w-100 tiny"
                            type="email"
                            placeholder="Ej. hola@arcux.net"
                          />

                          <span
                            v-if="!$v.profile.email.required"
                            class="c-form__error"
                          >
                            Email requerido
                          </span>
                          <span
                            v-else-if="!$v.profile.email.isValid"
                            class="c-form__error"
                          >
                            Email incorrecto
                          </span>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div
                          class="c-form-group"
                          :class="{'c-form-group--error' : $v.profile.mobile.$error}"
                        >
                          <label class="w-sbold fs-14 mb-1">Número de teléfono / Whatsapp*</label>
                          <VuePhoneNumberInput
                            v-model="$v.profile.mobile.$model"
                            class="c-form__phone tiny"
                            @update="updatePhoneDetails"
                            :default-country-code="profile.country_code"
                            :no-example="true"
                            :translations="translations"
                          />
                          <p class="mt-1">
                            <Switcher
                              :state.sync="profile.phone_show"
                              label="Mostrar en perfil"
                              class="fs-14"
                            />
                          </p>
                          <span
                            v-if="!$v.profile.mobile.required"
                            class="c-form__error"
                          >
                            Número de teléfono requerido
                          </span>
                          <span
                            v-else-if="!$v.profile.mobile.isValid"
                            class="c-form__error"
                          >
                            Número de teléfono incorrecto
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="d-flex justify-content-end align-items-center">
            <router-link to="/" class="c-link c-link--black small">
              Volver al panel
            </router-link>
            <button
              @click="updateProfile()"
              class="c-button c-button--primary small ms-3"
              :class="{loading : isUpdating}"
              :disabled="isUpdating || !isReadyForUpdate"
            >
              {{
                (isUpdating) ? 'Actualizando...' : 'Guardar cambios'
              }}
              <img
                class="c-button__spinner"
                src="@/assets/images/animations/spinner-white.png"
                alt="loading"
              />
            </button>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </section>
</template>

<script>
import { scroller } from 'vue-scrollto/src/scrollTo';
import VuePhoneNumberInput from 'vue-phone-number-input';
import { mapActions, mapState } from 'vuex';
import {
  required,
  minLength,
  helpers,
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      scroll: scroller(),

      switcherActions: false,

      softwares: [],

      profile: {
        user_id: -1,

        job: '',
        job_grade: '',
        schedule: '',
        description: '',
        skills: [],
        languages: [],
        educations: [],

        facebook: '',
        instagram: '',
        linkedin: '',
        twitter: '',

        email: '',
        firstname: '',
        lastname: '',
        mobile: '',
        phone_show: false,
        country_code: '',

        languageSelector: '',
        skillSelector: '',
      },

      isValidPhone: true,
      translations: {
        countrySelectorLabel: 'País',
        phoneNumberLabel: 'ej. 944444444',
      },

      isLoading: true,
      isUpdating: false,

      isReadyForUpdate: false,
      statusMessage: null,
    };
  },
  validations: {
    profile: {
      job_grade: {
        required,
      },
      job: {
        required,
        minLength: minLength(5),
      },
      schedule: {
        required,
      },
      description: {
        required,
        minLength: minLength(20),
      },
      skills: {
        required,
      },
      languages: {
        required,
      },
      email: {
        required,
        alpha: helpers.regex('alpha', /.+@.+\..+/),
      },
      firstname: {
        required,
      },
      lastname: {
        required,
      },
      mobile: {
        required,
        isValid: function isValidMobile() {
          return this.isValidPhone;
        },
      },
    },
    educations: {
      form: {
        location: {
          required,
        },
        field_study: {
          required,
        },
        start_date: {
          required,
        },
        end_date: {
          required,
        },
      },
    },
  },
  components: {
    VuePhoneNumberInput,
    Educations: () => import(/* webpackChunkName: "profile-educations" */'@/components/panel/edit/Educations.vue'),
    Switcher: () => import(/* webpackChunkName: "ui-switcher" */'@/components/ui/Switcher.vue'),
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    years() {
      const years = [];

      for (let year = new Date().getFullYear(); year >= 1900; year -= 1) {
        years.push(year);
      }

      return years;
    },
  },
  watch: {
    profile: {
      handler() {
        this.isReadyForUpdate = true;
      },
      deep: true,
    },
  },
  mounted() {
    this.getProfileData();
    this.getSoftwares();
  },
  methods: {
    ...mapActions(['updateConnectaProfile']),

    updatePhoneDetails(e) {
      this.isValidPhone = e.isValid;

      this.profile.country_code = e.countryCode;
    },
    updateSkills() {
      if (!this.profile.skills.find((skill) => skill === this.profile.skillSelector)) {
        this.profile.skills.push(this.profile.skillSelector);

        this.profile.skillSelector = '';
      }
    },
    updateLanguages() {
      if (!this.profile.languages.find((language) => language === this.profile.languageSelector)) {
        this.profile.languages.push(this.profile.languageSelector);

        this.profile.languageSelector = '';
      }
    },

    removeItem(type, item) {
      if (type === 'skill') {
        this.profile.skills = this.profile
          .skills
          .filter((skill) => item !== skill);
      } else if (type === 'language') {
        this.profile.languages = this.profile
          .languages
          .filter((language) => item !== language);
      }
    },

    getProfileData() {
      fetch(`${process.env.VUE_APP_API_V2}/work/profiles/${this.userData.id}/?mode=edit`)
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            const profile = {
              ...response.data,
              job_grade: response.data.job_grade ? response.data.job_grade : '',
              schedule: response.data.schedule ? response.data.schedule : '',
              skills: response.data.formatedSkills ? response.data.formatedSkills : [],
              languages: response.data.formatedLanguages ? response.data.formatedSkills : [],

              mobile: response.data.mobile,
              country_code: response.data.location?.country_code?.toUpperCase(),
            };

            response.data.social.forEach((item) => {
              profile[item.meta_key] = item.meta_value;
            });

            this.profile = {
              ...this.profile,
              ...profile,
            };

            this.updateConnectaProfile(profile);

            setTimeout(() => {
              this.isReadyForUpdate = false;
            }, 200);
          }
        })
        .catch((err) => {
          throw new Error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getSoftwares() {
      const request = `${process.env.VUE_APP_API}/courses/softwares`;

      fetch(request)
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.softwares = response.data;
          }
        })
        .catch(() => { });
    },

    updateProfile() {
      this.$v.profile.$touch();

      if (!this.$v.profile.$invalid) {
        this.isUpdating = true;

        fetch(`${process.env.VUE_APP_API_V2}/work/profiles/${this.userData.id}/`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...this.profile,
            phone_show: this.profile.phone_show ? 'enable' : 'disable',
            skills: this.profile.skills.join(','),
            languages: this.profile.languages.join(','),
          }),
        })
          .then((res) => {
            if (res.status === 200 || res.status < 300) {
              return res.json();
            }

            throw res;
          })
          .then((response) => {
            if (response.status) {
              this.statusMessage = {
                text: 'Datos actualizados exitosamente.',
                type: 'success',
              };
            } else {
              this.statusMessage = {
                text: 'Error al guardar sus datos, revise si todos estan correctos o intentelo más tarde.',
                type: 'error',
              };
            }
          })
          .catch(() => {
            this.statusMessage = {
              text: 'Error al guardar sus datos, revise si todos estan correctos o intentelo más tarde.',
              type: 'error',
            };
          })
          .finally(() => {
            this.scroll('#app');

            this.isUpdating = false;

            setTimeout(() => {
              this.statusMessage = null;
            }, 5000);
          });
      } else {
        this.scroll('#app');
      }
    },
  },
};
</script>
